export enum CODE_LOGIN {
  ACCESS_TOKEN = 'code-access-token',
  REFRESH_TOKEN = 'code-refresh-token',
  ACCESS_TOKEN_TIMEOUT = 'code-access-token-timeout',
  REFRESH_TOKEN_TIMEOUT = 'code-refresh-token-timeout',
}

export enum IDENTITY_TYPES {
  UNIVERSAL = 'UNIVERSAL',
  TENANT = 'TENANT',
  STUDENT = 'STUDENT',
  TEACHER = 'TEACHER',
  PARENT = 'PARENT',
  PROJECT = 'PROJECT',
  YFD_STAFF = 'YFD_STAFF',
  YFD_TEMP = 'YFD_TEMP',
}

export const IDENTITY_TYPES_ZH = {
  [IDENTITY_TYPES.STUDENT]: '学生',
  [IDENTITY_TYPES.TEACHER]: '教师',
  [IDENTITY_TYPES.PARENT]: '家长',
}

export enum ERROR_CODE {
  ERROR = '10000',
  BAD_REQUEST = '40000',
  UNAUTHORIZED = '40100',
  NO_PASSWORD = '40101',
  REVOKED_TOKEN = '40102',
  WRONG_VERIFICATION = '40103',
  NEW_PHONE_WRONG_VERIFICATION = '40104',
  OVER_FREQ = '40300',
  LOGIN_FAIL_OVER_FREQ = '40301',
  PHONE_FAIL_OVER_FREQ = '40302',
  REFRESH_OVER_FREQ = '40303',
  REFRESH_FAIL = '40304',
  USER_NOT_FOUND = '40400',
  DATA_CONFLICT = '40900',
  SERVICE_UNAVAILABLE = '50300',
}

export const ERROR_CODE_ZH = {
  [ERROR_CODE.ERROR]: '',
  [ERROR_CODE.BAD_REQUEST]: '',
  [ERROR_CODE.UNAUTHORIZED]: '手机号或密码不正确',
  [ERROR_CODE.NO_PASSWORD]: '手机号或密码不正确',
  [ERROR_CODE.REVOKED_TOKEN]: '',
  [ERROR_CODE.WRONG_VERIFICATION]: '手机号或验证码不正确',
  [ERROR_CODE.NEW_PHONE_WRONG_VERIFICATION]: '手机号或验证码不正确',
  [ERROR_CODE.OVER_FREQ]: '',
  [ERROR_CODE.LOGIN_FAIL_OVER_FREQ]: '已登录失败5次，为保障您的账号安全，请于 10 分钟后重试',
  [ERROR_CODE.PHONE_FAIL_OVER_FREQ]: '已验证失败5次，为保证您的账号安全，请于 10 分钟后重试',
  [ERROR_CODE.REFRESH_OVER_FREQ]: '请求过于频繁，请稍后再试',
  [ERROR_CODE.REFRESH_FAIL]: '无此学校权限，请联系学校管理员',
  [ERROR_CODE.USER_NOT_FOUND]: '账户不存在',
  [ERROR_CODE.DATA_CONFLICT]: '新手机号已被注册，请重新输入其他手机号或联系学校管理员',
  [ERROR_CODE.SERVICE_UNAVAILABLE]: '',
}

// node服务，不做用户校验
export const NODE_UNCHECK_USER = 'node-uncheck-user'

// 基础设置的权限key
export const TEACHER_MANAGEMENT_KEY = 'teacher_management'
export const POSITION_MANAGEMENT_KEY = 'position_management'
export const CONTRACT_MANAGEMENT_KEY = 'contract_management'
// Flying 选课权限key
export const LECTIO_FLYING = 'lectio_flying'

export enum TEACHER_INFO_MENU_ITEMS {
  PERSON_INFO = 'personInfo',
  SETTING = 'setting',
  TEACHER_MANAGE = 'teacherManage',
  SCHOOL_CHANGE = 'schoolChange',
  LOGOUT = 'logOut',
  UPLOAD_SCHOOL_PLAN = 'uploadSchoolPlan',
  FEEDBACK = 'feedback'
}
